import { Button, Pane, Text, Paragraph, Heading, Small, toaster } from 'evergreen-ui';

import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import { EmailSentIcon } from '../../components/icons';
import resendConfirmationEmail from '../../queries/resendConfirmationEmail';
import { StyledShadow } from '../Login';

const EmailVerificationPage = () => {
  const navigate = useNavigate();

  const { state } = useLocation();
  const token = state?.token;
  const email = state?.email;

  const [resent, setResent] = useState(false);
  const [resendTimeout, setResendTimeout] = useState(false);

  useEffect(() => {
    var timer = null;
    if (resendTimeout > 0) {
      timer = setTimeout(() => {
        setResendTimeout(resendTimeout - 1);
      }, 1000);
    }
    return () => {
      if (timer !== null) {
        clearTimeout(timer);
      }
    };
  }, [resent, resendTimeout]);

  const resendConfirmationEmailQuery = useMutation(resendConfirmationEmail, {
    useErrorBoundary: true,
    onSuccess: async data => {
      if (!data) return;
      toaster.notify('Email resent!');
    },
  });

  const resendEmail = async () => {
    if (email) {
      setResendTimeout(30);
      setResent(true);
      try {
        resendConfirmationEmailQuery.mutate({ token, email });
      } catch (error) {
        console.log(error);
      }
    } else {
      navigate('/app/login', { replace: true });
    }
  };

  return (
    <Pane
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100%"
      padding={16}
      paddingTop={0}
    >
      <Pane display="flex" flexDirection="column" alignItems="center" paddingY={50} position="relative">
        <StyledShadow />
        <EmailSentIcon />
      </Pane>
      <Heading color="#edeef2" size={700}>
        Email Verification
      </Heading>
      <Paragraph color="#636465" textAlign="center" paddingY={16}>
        <Small fontSize={14}>
          You are registered! We've sent you an email to your email address with instructions to verify your account.
        </Small>
      </Paragraph>
      <Paragraph color="#636465" textAlign="center">
        <Small fontSize={14}>Missing the email? Make sure to check you Spam of Junk folder.</Small>
        <Button
          onClick={resendEmail}
          appearance="primary"
          marginTop={30}
          height={58}
          width="100%"
          backgroundColor="#e78850"
          border="none"
          borderRadius={8}
          disabled={resendTimeout > 0}
        >
          <Text color="#fcfdfd" fontWeight={600} fontSize={15} letterSpacing={2}>
            RESEND {resendTimeout > 0 && <>({resendTimeout}s)</>}
          </Text>
        </Button>
      </Paragraph>
      <Pane display="flex" justifyContent="center" alignItems="center" paddingY={32}>
        <Text color="#636465">Return back to</Text>
        <Text
          fontWeight="bolder"
          color="#e78850"
          onClick={() => navigate('/app/login', { replace: true })}
          marginLeft={5}
          cursor="pointer"
        >
          Login
        </Text>
      </Pane>
    </Pane>
  );
};

export default EmailVerificationPage;
